module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/8d0a7f99db3078db7272769cf9f05a8e.png";